module.exports = __webpack_public_path__ + "img/tripadvisor-active-icon.6293a5ad.svg";